import { render } from "./Clue.vue?vue&type=template&id=b45ea76a&scoped=true"
import script from "./Clue.vue?vue&type=script&lang=js"
export * from "./Clue.vue?vue&type=script&lang=js"

import "./Clue.vue?vue&type=style&index=0&id=b45ea76a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45ea76a"]])

export default __exports__